import Siema from "siema";
import isElement from "lodash.iselement";
import { dom, mapActiveClass } from "../helpers/dom.js";


class FullGallery {
  constructor(images) {
    this._urls = images.filter(image => image !== "") || [];
  }
  init() {
    this._container = this._makeDom();
    if (this._images.length > 0) this.setActive(0);
    if (app && app.windowResizeObserver) {
      app.windowResizeObserver.subscribe(this.initWidget.bind(this));
    }
    return this._container;
  }
  initWidget() {
    if (app.isMobile) {
      this.slider = new Siema({
        selector: this._container,
        perPage: 1,
      });
    } else if (this.slider) {
      this.slider.destroy(true);
    }
  }
  setActive(targetIndex) {
    this._images.forEach((image, index) => {
      if (index === targetIndex) {
        image.classList.remove("full__image--hidden");
      } else {
        image.classList.add("full__image--hidden");
      }
    });
  }
  _makeDom() {
    this._images = this._urls.map(image =>
      dom("div.full__image.full__image--hidden", {}, [
        dom("img", { src: image }, null)
      ])
    );
    return dom("div.full__slider", {}, this._images);
  }
}

export default FullGallery;



// WEBPACK FOOTER //
// ./src/js/components/fullGallery.js